module.exports = __webpack_public_path__ + "static/media/1.19973a4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/1.jpg
// module id = 96
// module chunks = 0